export const createCssProperty = (
  propertyName: string,
  propertyValue: string,
) => {
  document.body.style.setProperty(propertyName, propertyValue);
};

export const removeCssProperty = (propertyName: string) => {
  document.body.style.removeProperty(propertyName);
};
